// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var JsxRuntime = require("react/jsx-runtime");
var Campaign$ReactHooksTemplate = require("./campaign.res.js");

function FollowUpSendingRule(props) {
  var displayValue = props.displayValue;
  var fieldValidation = props.fieldValidation;
  var campaign = props.campaign;
  var tmp;
  tmp = props.sendingFrequencyType === "Day" ? "days" : "hours";
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("span", {
                                    children: "Sending Limit",
                                    className: "text-sm font-medium text-gray-700"
                                  }),
                              className: "flex-1"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("input", {
                                            className: "w-20 h-10 border rounded-lg px-3 py-2 text-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent border-gray-300 bg-white hover:border-gray-400",
                                            disabled: false,
                                            min: "1",
                                            type: "number",
                                            value: String(Campaign$ReactHooksTemplate.sendingLimit(campaign)),
                                            onChange: props.handleSendingLimit
                                          }),
                                      className: "flex items-center space-x-2"
                                    }),
                                Curry._1(fieldValidation, Campaign$ReactHooksTemplate.sendingLimit(campaign))
                              ],
                              className: "ml-4 flex flex-col items-end"
                            })
                      ],
                      className: "flex items-center justify-between mb-15-px"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("span", {
                                    children: "Sending Frequency",
                                    className: "text-sm font-medium text-gray-700"
                                  }),
                              className: "flex-1"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("input", {
                                                    className: "w-20 h-10 border rounded-lg px-3 py-2 text-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent border-gray-300 bg-white hover:border-gray-400",
                                                    disabled: false,
                                                    min: "1",
                                                    type: "number",
                                                    value: String(displayValue),
                                                    onChange: props.handleSendingFrequency
                                                  }),
                                              JsxRuntime.jsxs("select", {
                                                    children: [
                                                      JsxRuntime.jsx("option", {
                                                            children: "hours",
                                                            value: "hours"
                                                          }),
                                                      JsxRuntime.jsx("option", {
                                                            children: "days",
                                                            value: "days"
                                                          })
                                                    ],
                                                    className: "h-10 border rounded-lg px-3 py-2 text-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent border-gray-300 bg-white hover:border-gray-400",
                                                    disabled: false,
                                                    value: tmp,
                                                    onChange: props.handleIntervalTypeChange
                                                  })
                                            ],
                                            className: "flex items-center space-x-2"
                                          }),
                                      Curry._1(fieldValidation, displayValue | 0)
                                    ],
                                    className: "flex flex-col"
                                  }),
                              className: "ml-4"
                            })
                      ],
                      className: "flex items-center justify-between mb-15-px"
                    })
              ]
            });
}

var make = FollowUpSendingRule;

exports.make = make;
/* react/jsx-runtime Not a pure module */
